import { ApiResponse } from "../utils/api/ApiProps";
import api from "../utils/api";
import { GetTableParams } from "./data-fetch-settings";
import { FormFieldsApiData } from "../types/settings/settings";
import { formFieldsData } from "../types/settings/FormFieldProps";

export const getFormFiled = async ({
  search_term,
  sort_column = "col_order",
  sort_order = "ASC",
  include_options = true,
  limit = 100,
}: GetTableParams = {}): Promise<ApiResponse<FormFieldsApiData>> => {
  const searchParams = new URLSearchParams();

  // Add search parameter if provided
  if (search_term) {
    searchParams.append("search_term", search_term);
  }

  // Add sorting parameters
  if (sort_column) {
    searchParams.append("sort_column", sort_column);
    searchParams.append("sort_order", sort_order);
  }

  // Add parameter to get all records
  searchParams.append("all", "true");

  // Add parameter to include options in the response
  if (include_options) {
    searchParams.append("include", "options");
  }
  if (limit) {
    searchParams.append("limit", limit.toString());
  }

  const response = await api.get<FormFieldsApiData>(
    `/columns/?${searchParams.toString()}`
  );
  return response;
};

// create new
export const createFormFiled = async (
  data: unknown
): Promise<ApiResponse<unknown>> => {
  const response = await api.req({
    url: "/columns/",
    method: api.Method.POST,
    body: data,
  });
  return response;
};

export const getColumnById = async (uuid: string): Promise<ApiResponse> => {
  const response = await api.get(`/columns/${uuid}`);
  return response;
};

// update form filed
export const updateFormFiled = async (
  uuid: string,
  data: formFieldsData
): Promise<ApiResponse<{ data: formFieldsData }>> => {
  const response = await api.req<{ data: formFieldsData }>({
    url: `/columns/${uuid}`,
    method: api.Method.POST,
    body: data,
  });
  return response;
};

// delete
export const deleteFormFiled = async (uuid: string): Promise<ApiResponse> => {
  const response = await api.req({
    url: `/columns/${uuid}`,
    method: api.Method.DELETE,
  });
  return response;
};
export interface ColumnOrderPayload {
  columns: {
    uuid: string;
    col_order: number;
  }[];
}

export const saveColumnOrder = async (orderData: {
  columns: { uuid: string; col_order: number }[];
}): Promise<ApiResponse<unknown>> => {
  const response = await api.req<{ orderData: unknown }>({
    url: "/columns/order",
    method: api.Method.POST,
    body: orderData,
  });

  return response;
};
